export default __webpack_public_path__ + "static/media/rayon.b1b90d66.png";